import drinks from './alcohol.yml'
import { DrinkTypes } from 'types/DrinkTypes'
import { createSelector } from 'reselect'
import { ConsumptionState } from 'stores/consumption'

/**
 * Conversion factor from g to ml,
 * According to https://www.wolframalpha.com/input/?i=1g+ethanol+in+ml
 */
const ETHANOL_WEIGHT_TO_VOLUME_FACTOR = 1.267

/**
 * Get the amount of pure ethanol for a specified kind of drink.
 * @return {number} in ml
 */
export function getPureEthanolVolume(
  numberOfGlasses: number,
  drinkType: DrinkTypes
): number {
  return (
    (numberOfGlasses || 0) *
    drinks[drinkType].ethanol *
    ETHANOL_WEIGHT_TO_VOLUME_FACTOR
  )
}

/**
 * @return in l
 */
export function getYearlyConsumptionOfPureEthanol(weeklyConsumption: number) {
  return weeklyConsumption * 52 * 0.001
}

const getDrinks = (state: ConsumptionState) => state.drinks

export const getMemoisedYearlyConsumption = createSelector(
  getDrinks,
  drinks => {
    const weeklyEthanolVolume = Object.entries(drinks).reduce<number>(
      (currentValue, [key, value]) =>
        currentValue + getPureEthanolVolume(value, key as DrinkTypes),
      0
    )
    return getYearlyConsumptionOfPureEthanol(weeklyEthanolVolume)
  }
)
